import { mutationTree } from "typed-vuex";
import { StatsRes } from "~/../types/lib/responses/admin/stats.res";
import state, { AdminState } from "./state";

/**
 * Admin module mutations.
 */
const mutations = mutationTree(state, {
    /**
     * Sets the admin stats.
     *
     * @param {AdminState} state Admin state to set in
     * @param {(StatsRes | undefined)} stats Stats to set
     */
    setStats(state: AdminState, stats: StatsRes | undefined): void {
        if (!stats) return;

        state.stats = stats;
    },

    /**
     * Clears the module state.
     *
     * @param {AdminState} state
     */
    clear(state: AdminState): void {
        state.stats = null;
    },
});

export default mutations;
